// extracted by mini-css-extract-plugin
export default {"tipIcon":"tipIcon-xOQrS","tipIconLeft":"tipIcon-left-ngKau","tipIconRight":"tipIcon-right-km0pe","sportContainer":"sport-container-WvdI0","saftyPadding":"saftyPadding-ie55C"};